import React from 'react';
import styles from './svg.css';

const CheckMarkSvg = () => (
  <div className={styles.checkMarkBg}>
    <svg
      className={styles.checkMark}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 102 85"
    >
      <title>Check Mark</title>
      <path
        className="st0"
        d="M35.2,81.1C33,81,31,80,29.5,78.3l-25-28.9c-2.9-3.6-2.3-8.8,1.3-11.7c3.4-2.7,8.2-2.3,11.2,0.8l19,21.8
    	  L85.1,6.5c3.1-3.4,8.4-3.6,11.7-0.5c3.4,3.1,3.6,8.4,0.5,11.7L41.9,78.5c-1.6,1.7-3.9,2.7-6.2,2.7L35.2,81.1z"
      />
    </svg>
  </div>
);

export default CheckMarkSvg;



// WEBPACK FOOTER //
// ./src/assets/CheckMarkSvg.jsx